import { forwarding_types } from './forwardingTypes';

export default [
  { value: forwarding_types.AUDIO, displayName: 'Áudio' },
  { value: forwarding_types.QUEUE, displayName: 'Fila' },
  { value: forwarding_types.EXTENSION, displayName: 'Ramal' },
  { value: forwarding_types.GENERIC_EXTENSION, displayName: 'Ramal Genérico' },
  { value: forwarding_types.RING_GROUP, displayName: 'Grupo de Toque' }
];
